export const PUBLIC_RESERVATION_SAFE_BRAND_FALLBACK = 'Reservation System powered by Mintleaf';

export type PublicBusinessIdentitySource = {
  publicIdentity?: {
    displayName?: unknown;
    brandName?: unknown;
  } | null;
  publicName?: unknown;
  displayName?: unknown;
  brandName?: unknown;
  unitName?: unknown;
  name?: unknown;
} | null | undefined;

export type ResolvePublicBusinessNameOptions = {
  allowLegacyUnitName?: boolean;
  allowLegacyName?: boolean;
  fallback?: string;
};

const normalizePublicBusinessName = (value: unknown): string | null => {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
};

export const resolvePublicBusinessName = (
  source: PublicBusinessIdentitySource,
  options: ResolvePublicBusinessNameOptions = {}
): string => {
  const resolved =
    normalizePublicBusinessName(source?.publicIdentity?.displayName) ||
    normalizePublicBusinessName(source?.publicName) ||
    normalizePublicBusinessName(source?.displayName) ||
    normalizePublicBusinessName(source?.brandName) ||
    (options.allowLegacyUnitName ? normalizePublicBusinessName(source?.unitName) : null) ||
    (options.allowLegacyName ? normalizePublicBusinessName(source?.name) : null);

  return resolved || options.fallback || PUBLIC_RESERVATION_SAFE_BRAND_FALLBACK;
};

export const buildPublicReservationTitle = (businessName: string): string =>
  `Foglalás - ${businessName || PUBLIC_RESERVATION_SAFE_BRAND_FALLBACK}`;


const PUBLIC_RESERVATION_WATERMARK_FALLBACK = 'Reservation System powered by MintLeaf.';

export const buildPublicReservationWatermark = (businessName?: string | null): string => {
  const normalizedBusinessName = normalizePublicBusinessName(businessName);
  if (
    !normalizedBusinessName ||
    normalizedBusinessName === PUBLIC_RESERVATION_SAFE_BRAND_FALLBACK ||
    normalizedBusinessName === PUBLIC_RESERVATION_WATERMARK_FALLBACK
  ) {
    return PUBLIC_RESERVATION_WATERMARK_FALLBACK;
  }

  return `${normalizedBusinessName} reservation system, powered by MintLeaf.`;
};
